import { TextField, withStyles } from "@material-ui/core";
import { displayValue } from "utils/randomKey";

export const rowStyle2 = (row, rowIndex) => {
  const style = {};
  style.backgroundColor = "#fff";
  return style;
};
export const commonStyle = {
  fontFamily: "Gt-Walsheim-medium",
  fontSize: "11px",
  fontWeight: "bold",
  textAlign: "center",
  textWrap: "wrap",
  wordBreak: "break-word",
  verticalAlign: "middle", // Center-align text vertically
};

export const commonHeaderStyle = {
  fontFamily: "Gt-Walsheim-medium",
  fontSize: "12px",
  fontWeight: "bold",
  verticalAlign: "text-top",
  backgroundColor: "#4f2d7f",
  color: "#fff",
  textWrap: "wrap",
  wordBreak: "break-word",
  // borderRight:'1px solid black'
};

export const displayNullFormatter = (row, property) => {
  return (
    <>
      {row[property] === null ||
      row[property] === undefined ||
      row[property] === ""
        ? "--"
        : row[property]}
    </>
  );
};

export const displayCommaFormatter = (row, property) => {
  return (
    <>
      {row[property] === null ||
      row[property] === undefined ||
      row[property] === ""
        ? "--"
        : displayValue(Number(row[property]))}
    </>
  );
};

export const CustomTextField = withStyles((theme) => ({
  root: {
    width: "100%",
    height: "2em",
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#4f2d7f", // border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "#4f2d7f", // border color on focus
      },
    },
  },
}))(TextField);

export const sortCaret = (order, column) => {
  const caretStyle = { cursor: "pointer", marginLeft: "5px" };

  if (!order) {
    return <span style={caretStyle}>&nbsp;⬍&nbsp;</span>; // Default (no sorting applied)
  }
  return order === "asc" ? (
    <span style={caretStyle}>⬆️</span>
  ) : (
    <span style={caretStyle}>⬇️</span>
  );
};

function cleanJsonString(jsonString) {
  // Remove extra quotes from the beginning and end of the string
  if (jsonString?.startsWith('"') && jsonString?.endsWith('"')) {
    jsonString = jsonString.slice(1, -1);
  }
  // Replace escaped quotes with regular quotes
  jsonString = jsonString?.replace(/\\"/g, '"');
  return jsonString;
}

export function parseJsonString(jsonString) {
  // Clean up the JSON string
  jsonString = cleanJsonString(jsonString);
  // Parse the JSON string
  const parsedData = JSON.parse(jsonString);
  // Initialize an empty array to store the result
  const result = [];
  // Helper function to process each key-value pair
  function processObject(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          processObject(obj[key]);
        } else {
          result.push({
            name: key,
            desc: obj[key] !== null ? obj[key].toString() : "null",
          });
        }
      }
    }
  }
  // Process the parsed data
  processObject(parsedData);
  return result;
}

// Function to convert date format
export const convertDateFormatYYYYMMDD = (dateString) => {
  return dateString.split("/").reverse().join("-");
};

export const rowStyleEinv = (row, rowIndex) => {
  const style = {};

  if (row.is_error == 1) {
    style.backgroundColor = "rgb(210 242 152)";
  } else if (row.is_error == 2) {
    style.backgroundColor = "#cbc4bc";
  } else if (row.is_error == 4) {
    style.backgroundColor = "rgb(185, 171, 204)";
  } else {
    style.backgroundColor = "#fff";
  }
  // if (
  //   colorMap.get(row.txn_id) != undefined &&
  //   colorMap.get(row.txn_id) == "1"
  // ) {
  //   style.backgroundColor = "rgb(255, 203, 165)";
  // }
  return style;
};

export const customStyles = {
  // Styles for the control (input) element
  control: (provided) => ({
    ...provided,
    color: "red",
    width: "200px",
    padding: "2px 2px",
    borderRadius: "8px",
    boxShadow: "none",
    // border: "none",
    // height:'50px'
    // textAlign: "left"
  }),
  menu: (provided) => ({
    ...provided,
    // width: "200px",
    overflowX: "hidden",
  }),
  // Styles for the options in the dropdown
  option: (provided, state) => ({
    ...provided,
    // width: "200px",
    textAlign: "center",
    color: "black",
    overflowX: "hidden",
    // color: state.isSelected ? "black" : "grey",
    backgroundColor: state.isSelected ? "lightgrey" : "white",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#00A4B3",
  }),
};

export const getWhiteData = (data) => {
  var txn_Noneditable = [];
  data.forEach((val, index) => {
    for (var key in val) {
      if (key == "0|is_error|is_error") {
        if (val[key] == null || val[key] == 0) {
          txn_Noneditable.push(val["0|txn_id|Txn_id"]);
        }
      }
    }
  });
  return txn_Noneditable;
};
/*  iterating thorugh an array of object to get an Error of nonInvoice data. */
export const nonInvoiceGenerateData = (data) => {
  var txn_NonsubmitData = [];
  data.forEach((val, index) => {
    for (var key in val) {
      if (key == "0|is_error|is_error") {
        if (val[key] == 1) {
          txn_NonsubmitData.push(val["0|txn_id|Txn_id"]);
        }
      }
    }
  });
  return txn_NonsubmitData;
};
export const nonGenerateData = (data) => {
  var txn_Noneditable = [];
  data.forEach((val, index) => {
    for (var key in val) {
      if (key == "is_error") {
        // if (key == "eway_is_error") { //need to veriufy with
        if (val[key] == 1) {
          txn_Noneditable.push(val["0|txn_id|Txn_id"]);
        }
      }
    }
  });
  return txn_Noneditable;
};
/*  iterating thorugh an array of object to get an Error of nonCacelation data. */
export const nonInvoiceCancelledData = (data) => {
  var txn_NonsubmitData = [];
  data.forEach((val, index) => {
    for (var key in val) {
      if (key == "0|is_error|is_error") {
        if (val[key] == 2) {
          txn_NonsubmitData.push(val["0|txn_id|Txn_id"]);
        }
      }
    }
  });
  return txn_NonsubmitData;
};
export const nonTxnNonsubmitData = (data) => {
  var txn_NonsubmitData = [];
  data.forEach((val, index) => {
    for (var key in val) {
      if (key == "0|is_error|is_error" || key == "0|txn_error|txn_error") {
        if (val[key] != 1 && val[key] != 2 && val[key] != 4) {
          txn_NonsubmitData.push(val["0|txn_id|Txn_id"]);
        }
      }
    }
  });
  return txn_NonsubmitData;
};

export const nonTxnEditData = (data) => {
  var txn_Noneditable = [];
  data.map((val, index) => {
    for (var key in val) {
      if (key == "eway_is_error") {
        if (val[key] == 1) {
          txn_Noneditable.push(val["0|txn_id|Txn_id"]);
        }
      }
    }
  });
  return txn_Noneditable;
};
